import styles from './ModeSelector.module.scss';
import Tooltip from '../Tooltip';

interface Props {
  isSecondOptionChecked: boolean;
  leftContent?: React.ReactNode;
  rightContent?: React.ReactNode;
  primaryColor: string;
  secondaryColor: string;
  borderColor?: string;
  width?: number;
  height?: number;
  tooltip1?: string;
  tooltip2?: string;
  handleSwitch: () => void;
}
const ModeSelector = ({
  isSecondOptionChecked,
  handleSwitch,
  leftContent,
  rightContent,
  primaryColor,
  secondaryColor,
  borderColor,
  tooltip1,
  tooltip2,
  width,
  height,
}: Props) => {
  return (
    <div
      className={styles.container}
      style={{
        width: width ? `${width}px` : '70px',
        height: height ? `${height}px` : '35px',
        borderColor: borderColor ? borderColor : 'black',
      }}
    >
      <div
        className={styles.leftBox}
        onClick={
          isSecondOptionChecked
            ? handleSwitch
            : () => {
                return null;
              }
        }
        style={{
          borderColor: borderColor ? borderColor : 'black',
          color: isSecondOptionChecked ? secondaryColor : primaryColor,
          backgroundColor: isSecondOptionChecked ? primaryColor : secondaryColor,
        }}
      >
        {tooltip1 ? (
          <Tooltip direction='bottom' arrowPosition='right-align' content={tooltip1} color='blue'>
            <div
              className={styles.hitBox}
              style={{
                width: width ? `${width / 2}px` : '35px',
                height: height ? height : '35px',
                position: 'relative',
              }}
            >
              {leftContent}
            </div>
          </Tooltip>
        ) : (
          { leftContent }
        )}
      </div>
      <div
        className={styles.rightBox}
        onClick={
          isSecondOptionChecked
            ? () => {
                return null;
              }
            : handleSwitch
        }
        style={{
          color: !isSecondOptionChecked ? secondaryColor : primaryColor,
          backgroundColor: !isSecondOptionChecked ? primaryColor : secondaryColor,
        }}
      >
        {tooltip2 ? (
          <Tooltip direction='bottom' arrowPosition='right-align' content={tooltip2} color='blue'>
            <div
              className={styles.hitBox}
              style={{
                width: width ? `${width / 2}px` : '35px',
                height: height ? height : '35px',
                position: 'relative',
              }}
            >
              {rightContent}
            </div>
          </Tooltip>
        ) : (
          { rightContent }
        )}
      </div>
    </div>
  );
};

export default ModeSelector;
